var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511 425.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e21c21;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5151e0c8492e5103c096af88a5218805",
    "data-name": "5151e0c8492e5103c096af88a5218805"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0V63.88L191.62,287.44V425.83H319.38V287.44L511,63.88V0ZM216.75,276.79,52.5,85.17H77.12L241.37,276.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.491f1e3fac05042e91d869f87ef0d62e.svg";
export { ForwardRef as ReactComponent };